import * as React from "react";

function BellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.479 5.749A4.502 4.502 0 0116.5 10v3.7l2.073 1.934a.5.5 0 01-.341.866H5.769a.5.5 0 01-.342-.866L7.5 13.7V10a4.502 4.502 0 013.021-4.251 1.5 1.5 0 012.958 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.585 18.5a1.5 1.5 0 002.83 0h-2.83z"
  }));
}

export default BellIcon;